import React from 'react';
import { useHistory } from 'react-router-dom';
import { IonIcon } from '@ionic/react';
import { leafOutline, snowOutline, waterOutline, optionsOutline } from 'ionicons/icons';
import type { Insight, StationInsight } from '../../../domain/WeatherStation';

const ICONS: Record<StationInsight['kind'], string> = {
  spray: leafOutline,
  frost: snowOutline,
  humidity: waterOutline,
};

const LEVEL_LABEL: Record<Insight['level'], string> = { ok: 'Apto', caution: 'Precaución', bad: 'No apto' };

// Lecturas "inteligentes" derivadas de los sensores: qué significa para el
// campo lo que está midiendo la estación ahora mismo, según sus umbrales.
// settingsHref: dónde se ajustan esos umbrales (si el usuario puede editarlos).
const StationInsights: React.FC<{ items: StationInsight[]; settingsHref?: string; customized?: boolean }> = ({
  items,
  settingsHref,
  customized,
}) => {
  const history = useHistory();
  if (items.length === 0) return null;
  return (
    <div className="station-insights">
      {items.map((item) => (
        <div className={`station-insight level-${item.level}`} key={item.kind}>
          <span className="station-insight-icon">
            <IonIcon icon={ICONS[item.kind]} />
          </span>
          <div className="station-insight-body">
            <p className="station-insight-title">
              {item.title}
              {item.kind === 'spray' && <span className="station-insight-pill">{LEVEL_LABEL[item.level]}</span>}
            </p>
            <p className="station-insight-detail">{item.detail}</p>
          </div>
        </div>
      ))}
      {settingsHref && (
        <button className="station-insights-settings" onClick={() => history.push(settingsHref)}>
          <IonIcon icon={optionsOutline} />
          {customized ? 'Criterios ajustados para esta estación · cambiar' : 'Ajustar criterios (Delta T, viento, helada…)'}
        </button>
      )}
    </div>
  );
};

export default StationInsights;
